<template>
  <div>
    <v-card>
      <v-data-table
        mobile-breakpoint="0"
        item-key="id"
        :items-per-page="5"
        :headers="getHeaders"
        :items="items"
        :server-items-length="totalCount"
        loading-text="Đang Tải"
        :loading="loading"
        disable-sort
        :footer-props="footerTable"
        no-data-text="Không có dữ liệu"
      >
        <template v-slot:[`item.name`]="{ item }">
          <router-link style="text-decoration: none" :to="`/club-detail/${item.id}`" dark>
            {{ item.name }}
          </router-link>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="elevation-0" icon @click="$router.push(`/club-detail/${item.id}`)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { headers } from './data'
export default {
  components: {},
  data() {
    return {
      pagination: {},
      pageText: ''
    }
  },
  computed: {
    ...mapState({
      items: state => state.club.items,
      totalCount: state => state.club.totalCount,
      loading: state => state.club.loading
    }),
    getHeaders() {
      return headers
    },
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số câu lạc bộ mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {}
}
</script>
